import { createContext, useContext } from "react";

const DEFAULT_AUTH_CONTEXT = {
    authed: false,
    solanaPubKey: "",
    jwt: "",
    verifiedPolygonAccts: [],
    saveVerifedPolygonAcct: (account) => {},
    doAuth: async () => false,
};

export const AuthContext = createContext(DEFAULT_AUTH_CONTEXT);

export function useAuth() {
    return useContext(AuthContext);
}
